module.exports = __webpack_public_path__ + "static/media/logo_round.c1934aed.png";